const fetchTerms = (target) => {
    let postType = target.value;

    // Fetch the terms for the selected post type
    fetch(bw_fl_builder.ajax_url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
            action: "bw_fetch_terms_for_post_type",
            post_type: postType,
            target: target,
            security: bw_fl_builder.ajax_nonce
        })
    })
        .then((response) => response.json())
        .then((terms) => {
            let select = target.closest('.fl-form-table').querySelector("select[name^=bw_featured_post_terms]");
            if (!terms) {
                select.innerHTML = 'No posts for selected post type';
                return;
            }

            let options = "";

            // Generate the options for the select field
            for (let term_id in terms) {
                options += '<option value="' + term_id + '">' + terms[term_id] + '</option>';
            }

            // Update the select field with the new options
            select.innerHTML = options;
        });
}

const fetchPosts = (target) => {
    let postType = target.value;

    const formTable = target.closest('.fl-form-table');

    formTable.closest('.fl-lightbox-content-wrap').classList.add('loading');

    // Fetch the posts for the selected post type
    fetch(bw_fl_builder.ajax_url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
            action: "bw_fetch_posts_for_post_type",
            post_type: postType,
            target: target,
            security: bw_fl_builder.ajax_nonce
        })
    })
        .then((response) => response.json())
        .then((posts) => {
            let select = formTable.querySelector("select[name^=bw_resource_post_object]");

            if (posts.length === 0) {
                select.innerHTML = 'No posts for selected post type';
                return;
            }
            let options = "";

            // Generate the options for the select field
            posts.forEach(post => {
                options += '<option value="' + post.ID + '">' + post['post_title'] + '</option>';
            });

            // Update the select field with the new options
            select.innerHTML = options;

            formTable.closest('.fl-lightbox-content-wrap').classList.remove('loading');
        });
}

jQuery(document).ready(function($) {
    if (typeof bw_fl_builder === 'undefined') {
        return;
    }

    let FLBuilderCheckAttempts = 0;

    const checkFLBuilder = setInterval(function() {
        FLBuilderCheckAttempts += 1;

        if (typeof FLBuilder !== 'undefined') {
            clearInterval(checkFLBuilder);

            FLBuilder.addHook('didShowLightbox', function () {
                const element = document.querySelector('.bw-fetch-posts');

                if(!element) return;

                if(element.value !== 'post') {
                    fetchPosts(element);
                }
            });

        } else if (FLBuilderCheckAttempts >= 20) { // 20 checks, at an interval of 500ms, equates to 10 seconds
            clearInterval(checkFLBuilder);
            console.log('FLBuilder did not become defined within 10 seconds.');
        }
    }, 500); // Check every 500ms

    document.body.addEventListener("change", function (event) {
        const {target} = event;

        if (target.classList.contains("bw-fetch-terms")) {
            fetchTerms(target);
        }

        if (target.classList.contains("bw-fetch-posts")) {
            fetchPosts(target);
        }
    });
});